// extracted by mini-css-extract-plugin
export default {"root":"PageBuilderColumn-module-root-28l"};